// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\" data-cy=\"transactionDetail-result\">\n        <transaction-result result=\"row.entity.ResultCode\"></transaction-result>\n    </div>\n</div>";
// Exports
module.exports = code;